import { setToken, getToken, curlHttp, setStore, getStore } from '@/library/utils'
import api from '../../library/api.service'
import minLogo from '@/assets/img/min-logo.png'

export default {
    state: {
        userName: '',
        userId: '',
        avatarImgPath: '',
        token: '',
        hasGetInfo: false,
        access: [],
        userInfo: {} || JSON.parse(getStore('userinfo')),
        webLogo: minLogo,
        messagelist: [],
        unreadCount: 0,
        messageUnreadList: [],
        messageReadedList: [],
        messageTrashList: [],
        messageContentStore: [],
        userlist: []
    },
    mutations: {
        setLogo(state, logoPath) {
            state.webLogo = logoPath
        },
        setAvatar(state, avatarPath) {
            state.avatarImgPath = avatarPath
        },
        setUserId(state, id) {
            state.userId = id
        },
        setUserName(state, name) {
            state.userName = name
        },
        setUserInfo(state, data) {
            state.userInfo = data
            setStore('userinfo', JSON.stringify(data))
        },
        setToken(state, token) {
            state.token = token
            setToken(token)
        },
        setAccess(state, access) {
            state.access = access
        },
        setHasGetInfo(state, status) {
            state.hasGetInfo = status
        },
        setMessageList(state, list) {
            state.messagelist = list
        },
        setMessageCount(state, count) {
            state.unreadCount = count
        },
        setMessageUnreadList(state, list) {
            state.messageUnreadList = list
        },
        setMessageReadedList(state, list) {
            state.messageReadedList = list
        },
        setMessageTrashList(state, list) {
            state.messageTrashList = list
        },
        updateMessageContentStore(state, { content }) {
            state.messageContentStore = content
        },
        setUserList(state, list) {
            state.userlist = list
        }
    },
    getters: {
        messageUnreadCount: state => state.messageUnreadList.length,
        messageReadedCount: state => state.messageReadedList.length,
        messageTrashCount: state => state.messageTrashList.length
    },
    actions: {
        FINDUSERNAME({ commit }, { value }) {
            return new Promise((resolve, reject) => {
                let params = {
                    username: value
                }
                let findusers = api.api.users.find
                curlHttp(findusers.url, params, findusers.method).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 登录
        handleLogin({ commit }, { userName, password }) {
            let username = userName.trim()
            password = password.trim()
            return new Promise((resolve, reject) => {
                let loginUrl = api.api.users.login
                curlHttp(loginUrl.url, {
                    username,
                    password
                }, loginUrl.method).then(res => {
                    if (res.code === 200) {
                        commit('setToken', res.detail.token)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 用户Code登录
        handleCodeLogin({ commit }, { Code }) {
            let code = Code.trim()
            return new Promise((resolve, reject) => {
                let loginUrl = api.api.users.codeLogin
                curlHttp(loginUrl.url, {
                    code,
                }, loginUrl.method).then(res => {
                    if (res.code === 200) {
                        commit('setToken', res.detail.token)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            return new Promise((resolve, reject) => {
                // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
                commit('setToken', '')
                commit('setUserInfo', '')
                commit('setUserName', '')
                commit('setAvatar', '')
                resolve()
                window.close()
            })
        },
        // 获取用户相关信息
        getUserInfo({ state, commit }) {
            return new Promise((resolve, reject) => {
                try {
                    let loginUrl = api.api.users.owninfo
                    curlHttp(loginUrl.url, {}, loginUrl.method).then(res => {
                        if (res.code == 200) {
                            const data = res.detail
                            commit('setUserInfo', data)
                            commit('setAccess', data.roles)
                            commit('setLogo', data.tenant_logo_url)
                            commit('setAvatar', data.img)
                            commit('setUserName', data.username)
                            commit('setHasGetInfo', true)
                            resolve(data)
                        }
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        },
        // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
        getUnreadMessageCount({ state, commit }) {
            let userinfo = JSON.parse(getStore('userinfo'))
            let params = {
                creator: userinfo.user_id,
                tenant_id: userinfo.tenant_id,
                is_read: 0
            }
            return new Promise((resolve, reject) => {
                let msCount = api.api.message.count
                curlHttp(msCount.url, params, msCount.method).then(res => {
                    if (res.code == 200) {
                        commit('setMessageCount', res.detail)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取消息列表，其中包含未读、已读、回收站三个列表
        getMessageList({ state, commit }) {
            return new Promise((resolve, reject) => {
                let userinfo = JSON.parse(getStore('userinfo'))
                let params = {
                    creator: userinfo.user_id,
                    tenant_id: userinfo.tenant_id,
                }
                return new Promise((resolve, reject) => {
                    let mslist = api.api.message.list
                    curlHttp(mslist.url, params, mslist.method).then(res => {
                        if (res.code == 200) {
                            let UnreadList = []
                            let ReadedList = []
                            let TrashList = []
                            commit('setMessageList', res.detail)
                            res.detail.filter((val) => {
                                if (val.is_read == 0) {
                                    UnreadList.push(val)
                                } else if (val.is_read == 1) {
                                    ReadedList.push(val)
                                } else if (val.is_read == 2) {
                                    TrashList.push(val)
                                }
                            })
                            commit('setMessageUnreadList', UnreadList)
                            commit('setMessageReadedList', ReadedList)
                            commit('setMessageTrashList', TrashList)
                        }
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                })
            })
        },
        // 根据当前点击的消息的id获取内容
        getContentByMsgId({ state, commit }, { content }) {
            return new Promise((resolve, reject) => {
                if (content) {
                    commit('updateMessageContentStore', { content })
                    resolve(content)
                } else {
                    let contentItem = state.messageContentStore
                    if (contentItem) {
                        resolve(contentItem)
                    }
                }
            })
        },
        // 把一个未读消息标记为已读
        hasRead({ state, commit }, content) {
            return new Promise((resolve, reject) => {
                let params = {
                    is_read: 1
                }
                let msupdate = api.api.message.update
                curlHttp(msupdate.url + content.id + '/', params, msupdate.method).then(res => {
                    if (res.code == 200) {
                        commit('setMessageCount', state.unreadCount - 1)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 删除一个已读消息到回收站
        removeReaded({ commit }, { msg_id }) {
            return new Promise((resolve, reject) => {
                removeReaded(msg_id).then(() => {
                    commit('moveMsg', {
                        from: 'messageReadedList',
                        to: 'messageTrashList',
                        msg_id
                    })
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        handleUserlist({ commit }) {
            return new Promise((resolve, reject) => {
                let params = {}
                let only = api.api.users.list
                curlHttp(only.url, {}, only.method).then(res => {
                    if (res.code == 200) {
                        commit('setUserList', res.detail)
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
}